import { connect } from 'react-redux';

import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { getFormSyncErrors, getFormValues, hasSubmitFailed } from 'redux-form';

import { useTransl } from 'shared/lib/i18n';

import GenericFormContainer from '../../Forms/GenericFormContainer';

import { requiredAndMaxSizeLimit } from '../../Forms/utils';

import { UPLOAD_FILE_FORM, allowedExtensions } from '../constants';

import { FILE_UPLOAD } from '../../Forms/fieldTypes';

const UploadFileFormComponent = (props) => {
  const { t } = useTransl();
  const {
    form,
    onSubmit,
    submitText = t('documentLibrary.upload'),
    formValues,
    formSyncErrors,
    formSubmitFailed,
  } = props;

  const file = formValues?.file || {};
  const isDisabledUpload =
    isEmpty(formValues) ||
    isEmpty(file) ||
    (formSubmitFailed && !isEmpty(formSyncErrors));
  const formData = [
    {
      keyName: 'file',
      label: t('documentLibrary.chooseFileToUpload'),
      fieldType: FILE_UPLOAD,
      placeholder: t('documentLibrary.selectNewFile'),
      validate: [requiredAndMaxSizeLimit],
      accept: allowedExtensions,
    },
  ];
  return (
    <GenericFormContainer
      form={form}
      formData={formData}
      onSubmit={onSubmit}
      submitText={submitText}
      isButtonDisabled={isDisabledUpload}
      backButton={false}
    />
  );
};

const mapStateToProps = (state) => ({
  formValues: getFormValues(UPLOAD_FILE_FORM)(state),
  formSyncErrors: getFormSyncErrors(UPLOAD_FILE_FORM)(state),
  formSubmitFailed: hasSubmitFailed(UPLOAD_FILE_FORM)(state),
});

UploadFileFormComponent.defaultProps = {
  formValues: {},
  formSyncErrors: {},
  formSubmitFailed: false,
};

UploadFileFormComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.string.isRequired,
  submitText: PropTypes.string,
  formValues: PropTypes.instanceOf(Object),
  formSyncErrors: PropTypes.instanceOf(Object),
  formSubmitFailed: PropTypes.bool,
};

export default compose(connect(mapStateToProps, null))(UploadFileFormComponent);
